
const videoElements = document.querySelectorAll('.video-wrapper video');
    videoElements.forEach((videoElement) => {
        const playpausebtn = videoElement.nextElementSibling;
        // console.log(playpausebtn, 'lv-video-loop__sound-button')
        const soundbtn = playpausebtn.querySelector(".lv-video-loop__sound-button");
        const soundoff = soundbtn.querySelector(".sound-off");
        const soundon = soundbtn.querySelector(".sound-on");
        if (soundbtn) {
            soundbtn.addEventListener("click", function(e) {
                e.preventDefault()
                if (videoElement.muted) {
                    document.querySelectorAll('video').forEach((otherVideo) => {
                        if (otherVideo != videoElement) {
                            otherVideo.muted = true;
                            const otherSoundButtons = otherVideo.nextElementSibling.querySelector(".lv-video-loop__sound-button");
                            if (otherSoundButtons) {
                                otherSoundButtons.querySelector(".sound-off").classList.remove("hide");
                                otherSoundButtons.querySelector(".sound-on").classList.add("hide");
                            }
                        }
                    });
                    videoElement.muted = !videoElement.muted;
                    soundon.classList.remove("hide");
                    soundoff.classList.add("hide");
                    videoElement.removeAttribute("muted");
                    this.classList.add('playing');
                } else {
                    videoElement.muted = true;
                    soundon.classList.add("hide");
                    soundoff.classList.remove("hide");
                    videoElement.setAttribute("muted" , "true");
                    this.classList.remove('playing');
                }
            })
        }
    })
const videos = document.querySelectorAll("video");
    videos.forEach((video) => {
        video.addEventListener("timeupdate", () => {
        video.classList.add("loaded");
        }, { once: true });
    });
//Text Video Section
var text_video = document.querySelector('.text-video-about');
var text_video_data = text_video.getAttribute("data-section");
var text_video_wrap = text_video.querySelectorAll('.video-wrapper video');
text_video_wrap.forEach((videoElement) => {
  videoElement.play()
  console.log(videoElement,"videoElement")
})
console.log(text_video_data,"text_video_data")
document.querySelectorAll('.video-play-pausebutton').forEach((videobtn) => {
  var section = videobtn.dataset.section;
  console.log(section,"section")
  videobtn.addEventListener("click", function(e) {
        document.querySelector(`#text-video-${section}`).classList.remove('hide_video_element');
        if(e.target.dataset.video == 'off'){
            e.target.classList.add('hide');
            videobtn.querySelector('span.video-on').classList.remove('hide');
            document.querySelector(`#text-video-${section} .video-wrapper video`).play();
        } else {
            e.target.classList.add('hide');
            videobtn.querySelector('span.video-off').classList.remove('hide');
            document.querySelector(`#text-video-${section} .video-wrapper video`).pause();
        }
        
    })
  document.querySelector(`#text-video-${section} .video-close`).addEventListener('click', () => {
            document.querySelector(`#text-video-${section} .video-wrapper video`).pause();
            document.querySelector(`#text-video-${section} .video-wrapper video`).currentTime = 0;


            document.querySelector(`#text-video-${section}`).classList.add('hide_video_element');
            videobtn.querySelector('span.video-off').classList.remove('hide');
            videobtn.querySelector('span.video-on').classList.add('hide');
        });
})

const slides = document.querySelectorAll('.js-image-slider-about .slide');
let currentIndex = 0;
function showSlide(index) {
    slides.forEach((slide, i) => {
        if (i === index) {
            slide.style.display = 'block';
        } else {
            slide.style.display = 'none';
        }
    });
}
var screenWidth = window.innerWidth;
// console.log(screenWidth);
  if (screenWidth <= 640) {
    // Reference to the target div
    
    const swipeDiv = document.querySelector('.js-image-slider-about');
    
    let startX, startY, distX, distY, isSwiping = false;
    
    swipeDiv.addEventListener('touchstart', function(e) {
      const touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      isSwiping = false;
    });
    
    swipeDiv.addEventListener('touchmove', function(e) {
      if (!startX || !startY) return;
    
      const touch = e.touches[0];
      distX = touch.clientX - startX;
      distY = touch.clientY - startY;
    
      if (Math.abs(distX) > Math.abs(distY)) {
        // Horizontal swipe detected
        isSwiping = true;
      }
    });
  swipeDiv.addEventListener('touchend', function() {
  if (isSwiping) {
    if (distX < 0) {
      // Swiped right to left
    
      currentIndex = (currentIndex + 1) % slides.length;
        showSlide(currentIndex);
    } else if (distX > 0) {
      // Swiped left to right
      
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        showSlide(currentIndex);
    }
  }
  // Reset values
  startX = startY = distX = distY = isSwiping = 0;
});
   
  }
const prevButton = document.querySelector('.js-image-slider-about #prevButton');
const nextButton = document.querySelector('.js-image-slider-about #nextButton');

prevButton.addEventListener('click', () => {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    showSlide(currentIndex);
});

nextButton.addEventListener('click', () => {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
});

// Initial display 
showSlide(currentIndex);



/* Animated Text */
document.addEventListener("DOMContentLoaded", function() {
  gsap.registerPlugin(ScrollTrigger);
  
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".animated_text",
      scrub: true,
      pin: true,
      start: "50% 50%",
      end: window.innerWidth <= 640 ? "+=150%" : "+=250%", // 200% for mobile, 300% for larger screens
    }
  }).from(".large-text", {
    scale: 3.225,
    ease: "power1.inOut",
    duration:1
  })
  
  const vertical_scroll_parent = document.querySelector('.vertical_scroll-parent');
  var t = document.querySelector('.vertical_scroll-grid');
  const t21 = gsap.timeline({
    scrollTrigger: {
      trigger: vertical_scroll_parent,
      pinSpacing: !1,
      scrub: true,
      pinType: 'fixed',
      pin: vertical_scroll_parent,
      start: "top top",
      endTrigger: t,
      end: 'bottom top',
      scrub: 1,
      ease: Power0.easeNone,
      force3D: true
    }
  });
  
  const imageTimeline = gsap.timeline();
  
  const boxes = document.querySelectorAll('.box_main');
  boxes.forEach((box) => {
     const speed = parseFloat(box.getAttribute('data-speed')); // Get the speed from data-speed attribute
     const y = parseInt(box.getAttribute('data-y')); // Get the speed from data-speed attribute
    // Adjust the duration based on the speed (you can modify this formula as needed)
      const duration = window.innerWidth <= 640 ? 1 : 2 / speed; // Increase the denominator for slower scroll
      
     
    imageTimeline.to(box, {
        y: y,
        yPercent: window.innerWidth <= 640 ? 50 * (1 - speed) : -100 * (1 - speed), // Use negative percentage
        scrollTrigger: {
            trigger: box,
            scrub: true,
            start: "top bottom",
            end: "bottom -100%",
            duration: duration, // Adjust the duration based on the speed
            ease: Power0.easeNone,
            force3D: true
        },
        useFrames: true
    })
  });
  })
  